import { render } from "./SectionTeacherTopList.vue?vue&type=template&id=e219c248"
import script from "./SectionTeacherTopList.vue?vue&type=script&lang=js"
export * from "./SectionTeacherTopList.vue?vue&type=script&lang=js"

import "./SectionTeacherTopList.vue?vue&type=style&index=0&id=e219c248&lang=scss"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__